var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsHmax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 95.3899V185C3 190.523 7.47715 195 13 195H86H159C164.523 195 169 190.523 169 185V95.3899C169 92.8065 168 90.3233 166.21 88.4606L93.2101 12.5023C89.2752 8.40796 82.7248 8.40797 78.7899 12.5023L5.78992 88.4607C3.9998 90.3233 3 92.8065 3 95.3899Z",
    stroke: "black",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.75 197.5L198.297 177.5H175.203L186.75 197.5ZM186.75 10.9998L175.203 30.9998H198.297L186.75 10.9998ZM188.75 179.5V28.9998H184.75V179.5H188.75Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106 8L196 8",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsHmax);
export default __webpack_public_path__ + "static/media/ico_buildings_hmax.100620bd2927ff11806caa5bbb4f5f6b.svg";
export { ForwardRef as ReactComponent };